import { createSelector } from 'reselect';

const applicantsStateSelector = state => state.pendingApplicants;
const selectById = (state, itemId) => itemId;

export const applicantsSelector = createSelector(
  [applicantsStateSelector],
  applicants => applicants.items
);

export const applicantsListSelector = createSelector(
  [applicantsSelector],
  applicants =>
    applicants.map(applicant => ({
      name:
        applicant.userData[0].firstName + ' ' + applicant.userData[0].lastName,
      _id: applicant._id
    }))
);

export const applicantByIdSelector = createSelector(
  [applicantsSelector, selectById],
  (applicants, _id) => {
    const applicant = applicants.find(item => _id === item._id);
    if (!applicant) return null;
    return {
      ...applicant,
      name:
        applicant.userData[0].firstName + ' ' + applicant.userData[0].lastName,
      picture: applicant.userData[0].picture,
      skillsTrans: applicant.skills.map(data => data.skill).toString()
    };
  }
);

export const pendingApplicantsIsLoadingSelector = createSelector(
  [applicantsStateSelector],
  applicants => applicants.isLoading
);

export const applicantsCountSelector = createSelector(
  [applicantsStateSelector],
  applicants => applicants.count
);

/* export const searchValueSelector = createSelector(
  [applicantsStateSelector],
  (applicants) => applicants.searchValue
);
 */
